import "../../../../assets/css/AddCatalogs.css";
import React, { useEffect, useState } from "react";
import CatalogTitle from "../../../../components/Moleculas/Catalog Text/CatalogTitle";
import GoBack from "../../../../components/Moleculas/GoBack";
import { useLocation } from "react-router-dom";
import NotesList from "./NotesList";
import { useSelector } from "react-redux";
import { Appstore } from "../../../../redux";
const WSGDots = require("../../../../assets/images&icons/WSGDots.svg");

const ViewNotes: React.FC = () => {
  const {state} = useLocation();
  const manageFirm = useSelector((state: Appstore) => state.manageFirm);

  return (
    <>
        <div className="flex flex-col gap-10 justify-end">
          <NotesList noteList={state?.firmNotes ?? []} stateData={state} />
        </div>
    </>
  );
};

export default ViewNotes;
